
import { Link } from "react-router-dom";

interface StoryCardProps {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  isNewest?: boolean;
}

export const StoryCard = ({ id, title, excerpt, author, date, isNewest }: StoryCardProps) => {
  return (
    <Link to={`/story/${id}`} className="block">
      <article className={`${
        isNewest ? 'bg-[#FFE4CC] border-[#D46F4D]' : 'bg-story-background border-[#D46F4D]/20'
      } p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow animate-fade-up border relative`}>
        {isNewest && (
          <div className="absolute -top-3 left-4 bg-[#D46F4D] text-white px-3 py-1 rounded-full text-sm">
            Newest Story
          </div>
        )}
        <h2 className="text-xl font-semibold mb-2 text-[#2C1810]">{title}</h2>
        <p className="text-[#594A42] mb-4 line-clamp-3">{excerpt}</p>
        <div className="flex items-center justify-between text-sm text-[#8B6D63]">
          <span>{author}</span>
          <span>{date}</span>
        </div>
      </article>
    </Link>
  );
};
